import * as React from 'react'
import classNames from 'classnames'

export interface Props {
  displayClasses?: string
  raised?: boolean
}

const Box: React.FC<Props> = ({
  displayClasses,
  raised = false,
  children,
  ...rest
}) => {
  const classes = classNames('box', displayClasses, {
    'box--raised': raised,
  })

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}

export default Box
